<template>
  <div id="markdown-viewer" class="md-viewer">
    <!-- Loading -->
    <div v-if="loading" class="md-loading">
      <div class="md-loading-spinner"></div>
      <span class="md-loading-text">Loading markdown content...</span>
    </div>

    <!-- Error -->
    <div v-else-if="errorMsg" class="md-error">
      <span class="md-error-icon">⚠️</span>
      <span class="md-error-text">{{ errorMsg }}</span>
    </div>

    <!-- Rendered markdown -->
    <div
      v-else-if="htmlContent"
      class="md-content"
      v-html="htmlContent"
    ></div>

    <!-- Empty -->
    <div v-else class="md-empty">
      <span>No markdown content available.</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { marked } from 'marked'

const props = defineProps({
  content: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  errorMsg: { type: String, default: '' },
})

marked.setOptions({
  gfm: true,
  breaks: true,
})

const htmlContent = computed(() => {
  if (!props.content) return ''
  try {
    return marked.parse(props.content)
  } catch {
    return '<p style="color: var(--accent-red)">Failed to parse markdown content.</p>'
  }
})
</script>
